
/**
 * Назначает регулярное выражение
 * @param {string} type Тип регулярного выражения
 * @param {number} decimalPlaces Количество знаков после запятой.
 * @returns {string} regExp Регулярное выражение
 */
export const defineRegExp = (type, decimalPlaces) => {
  let regExp
  switch (type) {
    case 'text':
      regExp = /[.!@?#"№$%&:';()*+,/;\-=[\\\]^_{|}<>~`]/g
      break
    case 'sum':
      const expression = `^\\.|^0{2,}|[^.\\d]|\\.{2,}|\\.\\d{${1 + decimalPlaces},}|\\.\\d+\\.`
      regExp = new RegExp(expression, 'g')
      break
    case 'review':
      regExp = /[<>[\\\]{}]/g
      break
    default:
      regExp = /\D/g
  }
  return regExp
}

/**
 * Убирает из значения поля все символы, согласно регулярному выражению
 * @param {Object} event Событие input
 * @param {string} type Тип регулярного выражения
 * @param {boolean} isFractional Признак дробной части
 * @param {number} decimalPlaces Количество знаков после запятой.
 * @param {boolean} commaAsDot В качестве разделителя используется запятая вместо точки.
 */
export const handleFieldInput = (
  event,
  type,
  isFractional = false,
  decimalPlaces = 2,
  commaAsDot = false
) => {
  const regExp = defineRegExp(type, decimalPlaces)
  let value = (event && event.currentTarget && event.currentTarget.value) || ''

  if (commaAsDot) {
    value = value.replace(',', '.')
  }

  const matchedValue = value ? String(value).match(regExp) : null
  if (
    type === 'sum'
    && value.length > 1
    && value[0] === '0'
    && value[1] !== '.'
  ) {
    value = value.substring(1, value.length)
  }
  if (matchedValue) {
    const cursorPosition = event.currentTarget.selectionEnd - 1
    if (isFractional) {
      const expression = `\\d+\\.?\\d{0,${decimalPlaces}}`
      const regExpDecimal = new RegExp(expression)
      const newValue = value
        .replace(/^0{2,}|[^.\d]/g, '')
        .match(regExpDecimal)
      value = newValue ? newValue[0] : ''
    } else {
      value = value.replace(regExp, '')
    }
    event.currentTarget.selectionEnd = cursorPosition
  }

  if (commaAsDot) {
    value = value.replace('.', ',')
  }

  event.currentTarget.value = value
}
